import clsx from "clsx";
import PropTypes from "prop-types";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

export const DocumentsDropdownFilter = ({
  className,
  data,
  value,
  disabled,
  onOptionSelected,
  placeholder,
  formatter = (value) => value,
}) => {
  return (
    <Dropdown
      onOptionSelected={onOptionSelected}
      className={clsx("documents-dropdown-filter", className)}
      selected={value}
      disabled={disabled}
      filled
    >
      <DropdownButton placeholder={placeholder} clearEnabled>
        {formatter(value)}
      </DropdownButton>
      <DropdownItems>
        {data.map((option) => (
          <DropdownItem key={option} value={option}>
            {formatter(option)}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
};

DocumentsDropdownFilter.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
  value: PropTypes.array,
  disabled: PropTypes.bool,
  onOptionSelected: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
